import { BACKEND_ENDPOINTS } from "Theconstants";
import { clearError, startAction, successLogin } from "context/userSlice";
import { axiosPOSTLogin } from "./axios";
import { errorHandler } from "./errorHandler";
import { AppDispatch } from "context/store";
import { UpdatePasswordInputs } from "pages/UserProfile/auxiliaries/data";

export const profileAPI = {
  getProfile: async function (dispatch: AppDispatch) {
    dispatch(startAction());

    try {
      const { data } = await axiosPOSTLogin.get<IUser>(
        BACKEND_ENDPOINTS.PROFILE
      );

      dispatch(successLogin(data));
    } catch (error) {
      errorHandler(error, dispatch, "GET USER PROFILE");
    }
  },
  editName: function (body: IUser) {
    return axiosPOSTLogin.put<IUser>(BACKEND_ENDPOINTS.PROFILE, body);
  },
  editPwd: function (passwordsObj: UpdatePasswordInputs) {
    return axiosPOSTLogin.put<void>(
      BACKEND_ENDPOINTS.PROFILE_EDIT_PWD,
      passwordsObj
    );
  },

  getAllClients: async function (dispatch: AppDispatch) {
    dispatch(startAction());
    try {
      const { data } = await axiosPOSTLogin.get<IUser[]>(
        `${BACKEND_ENDPOINTS.PROFILE}/all`
      );
      dispatch(clearError());
      return Promise.resolve(data);
    } catch (error) {
      errorHandler(error, dispatch, "GET ALL USERS");
      return Promise.reject();
    }
  },
};
